import { config as devToolsConfig } from "./config";

export function closeWindow() {
  if (window.location.pathname !== '/closeDevTools') {
    window.location.href = devToolsConfig.url;
  }
}